import React from 'react';

const ButtonAccount = ({ label, className, onClick, type, disabled }) => {
  return (
    <button
      disabled={disabled}
      type={type}
      className={`${className ? className : ''} text-base pl-4 ${disabled && 'text-gray-light'}`}
      onClick={onClick}>
      <span className="text-xl underline">{label}</span>
    </button>
  );
};

export default ButtonAccount;
